import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { ChangePlanDialogComponent } from './change-plan-dialog.component';
import { ChangePlanService } from './change-plan-service';

@NgModule({
  imports: [
    CommonModule,
    MatRadioModule,
    MatDialogModule,
    MatCheckboxModule,
    MatButtonModule,
    FormsModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
  declarations: [ChangePlanDialogComponent],
  providers: [ChangePlanService],
})
export class ChangePlanDialogModule {}
